// TIP-494 (MV Stage 5) — copy for the dashboard Membership page, per the
// approved design. Three audiences:
//   MEMBERSHIP_BENEFITS — pitched to a non-member (claimed) company
//   HAVE_BENEFITS       — what an active member already enjoys
//   UNLOCK_BENEFITS     — what requesting (free) verification adds on top
// Placeholder-but-final-ish wording from product; tweak in one place here.

// Shown on the claimed state ("What you get with membership").
export const MEMBERSHIP_BENEFITS = [
  {
    title: "Present your payment endorsements",
    body: "Show the market how your customers vouch for your payment track record.",
  },
  {
    title: "View members' endorsements",
    body: "See payment endorsements across every other member company — with no limits.",
  },
  {
    title: "Partner program access",
    body: "Get into the TREVEX partner program.",
  },
  {
    title: "Discounted TREVEX products",
    body: "Member rates on credit reports, compliance checks and more.",
  },
  {
    title: "The option to get verified",
    body: "Members can request a free verification review to earn the Verified badge.",
  },
];

// Shown on the member state, left panel ("Your membership" — already active).
export const HAVE_BENEFITS = [
  {
    title: "Present your payment endorsements",
    body: "Your customers' endorsements of your payment record are live to the market.",
  },
  {
    title: "View members' endorsements",
    body: "Browse payment endorsements across every other member company — unlimited.",
  },
  {
    title: "Partner program access",
    body: "You're in the TREVEX partner program.",
  },
  {
    title: "Discounted TREVEX products",
    body: "Member rates on credit reports, compliance checks and more.",
  },
];

// Shown on the member state, right panel ("Add verification" — free perk).
export const UNLOCK_BENEFITS = [
  {
    title: "The green Verified badge",
    body: "Once approved, your profile shows the TREVEX Verified badge — proof every data point on it has been checked.",
  },
  {
    title: "Reviewed by our team",
    body: "An admin asks for documents supporting your profile data, then approves. It validates your directory data, not a credit-risk grade.",
  },
  {
    title: "Free, and all-or-nothing",
    body: "Verification never costs anything. We verify everything visible; any section we can't confirm is removed first, and you decide before we proceed.",
  },
];

// Membership plans (AED) — mirror PaymentScreen.PLAN_PRICES. The actual Stripe
// checkout + toggle live on /membership/:companyId; these drive the dashboard
// plan selector and the preselected billing cycle passed through router state.
export const MEMBERSHIP_PLANS = {
  yearly: { id: "yearly", label: "Yearly", price: 999, perMonth: 83 },
  monthly: { id: "monthly", label: "Monthly", price: 99 },
};
